// extracted by css-extract-rspack-plugin
export default {"horizontalButton":"UgFcU","nested":"_MEhK","inner":"pMUGl","label":"vbRlx"};